var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.iconClasses,attrs:{"xmlns":"http://www.w3.org/2000/svg","role":_vm.alt ? 'img' : undefined,"viewBox":_vm.viewBox,"aria-hidden":!_vm.alt ? 'true' : undefined}},[(_vm.alt)?_c('title',[_vm._v(_vm._s(_vm.alt))]):_vm._e(),_vm._v(" "),_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.svg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }